import CrearListado from "../data/CraerListado"

const NO = () => {
    return (
        <CrearListado zona="no" />
    )
}

export default NO